import { render, staticRenderFns } from "./StoriesPage.vue?vue&type=template&id=22ed69ba&scoped=true&"
import script from "./StoriesPage.vue?vue&type=script&lang=js&"
export * from "./StoriesPage.vue?vue&type=script&lang=js&"
import style0 from "./StoriesPage.vue?vue&type=style&index=0&id=22ed69ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ed69ba",
  null
  
)

export default component.exports